const SCOPES = {
  BET_INTEGRATIONS_RESTRICTIONS: 'bet-has-integrations-restrictions',
  BET_INTEGRATIONS_WRITE: 'bet-integrations-write',
  BUSINESS_UNITS_ACCESS: 'business-units-access',
  CONVERSATIONS_ACCESS_SCOPE: 'conversations-access',
  CONVERSATIONS_ADMIN_SCOPE: 'conversations-admin',
  CRM_ACCESS: 'crm-access',
  DEVELOPER_PORTAL_ACCESS: 'developer-portal-access',
  CRM_EDIT_ALL: 'crm-edit-all',
  CUSTOM_OBJECT_ACCESS: 'custom-object-access',
  DEVELOPERS_READ: 'developers-read',
  DOMAIN_VERIFICATION_ACCESS: 'domain-verification-access',
  ESP_SYNC_ACCESS: 'esp-sync-access',
  HUB_MARKETING_PRODUCT: 'hub-marketing-product',
  INTEGRATIONS_ACCESS: 'integrations-access',
  INTEGRATIONS_MANAGEMENT: 'integrations-management',
  INTEGRATIONS_MANAGEMENT_UNINSTALL_ACCESS: 'integrations-management-uninstall-access',
  LISTS_ACCESS: 'contacts-lists-access',
  LISTS_READ: 'contacts-lists-read',
  MARKETABLE_CONTACTS_WRITE: 'marketable-contacts-write',
  MARKETABLE_CONTACTS_ACCESS: 'marketable-contacts-access',
  MARKETING_FREE_PRODUCT: 'marketing-free-product',
  MARKETING_STARTER_PRODUCT: 'marketing-starter-product',
  MARKETING_VIDEO: 'marketing-video',
  OPS_HUB_FIELD_MAPPINGS_CUSTOMIZATION: 'ops-sync-field-mappings-customization-access',
  SALESFORCE_ACCESS: 'salesforce-access',
  SALESFORCE_COB_WRITE: 'salesforce-cob-sync-write-access',
  // Grants access to salesforce COB write operations
  SALESFORCE_SETTINGS_WRITE: 'salesforce-settings-write',
  SLACK_SETTINGS_WRITE: 'integrations-slack-settings-write',
  STRATEGIC_INTEGRATIONS_ADMIN: 'strategic-integrations-admin',
  SUPER_ADMIN: 'super-admin',
  WORKFLOWS_ACCESS: 'workflows-access',
  ZOOM_SETTINGS_WRITE: 'integrations-zoom-settings-write',
  GOOGLE_SEARCH_CONSOLE_ACCESS: 'google-search-console-access',
  ZORSE_WEBTICKET: 'zorse-webticket',
  // eslint-disable-next-line hubspot-dev/no-private-classes
  PRIVATE_APPS_READ: 'private-apps-read',
  ZORSE_CHATFLOW_TARGETING_PRO: 'zorse-chatflow-targeting-pro',
  ZORSE_CHATFLOW_TARGETING_ENTERPRISE: 'zorse-chatflow-targeting-enterprise'
};
export default SCOPES;